import { supabase } from "@/lib/supabase";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { Recipe } from "@/features/Recipes-renamed/types";
import { mapDatabaseRecipeToRecipe, type RecipesRowWithRelations } from "@/lib/mapDatabaseRecipeToRecipe";
import { useAuthContext } from "@/features/authentication/useAuthContext";

export function useRecentlyAddedRecipes(limit: number): UseQueryResult<Recipe[]> {
    const { user } = useAuthContext();
    return useQuery({
        enabled: !!user,
        queryKey: ["recentlyAddedRecipes", limit],
        queryFn: async () => {
            const { data, error } = await supabase
                .from("recipes")
                .select(
                    `
                        *,
                        recipe_types (*),
                        recipe_categories (*),
                        ingredient_groups (*, ingredients (*))
                    `
                )
                .eq("user_id", user!.id)
                .order("created_at", { ascending: false })
                .limit(limit);

            if (error || !data) {
                console.error("Error fetching recently added recipes:", error);
                throw error;
            }

            return data.map((row) => mapDatabaseRecipeToRecipe(row as unknown as RecipesRowWithRelations));
        }
    });
}
